import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-icon",
  "use": "icon-more-icon-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol viewBox=\"0 0 18 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more-icon\">\n<rect width=\"18\" height=\"12\" rx=\"2\" fill=\"white\" />\n<circle cx=\"5\" cy=\"6\" r=\"1\" fill=\"black\" />\n<circle cx=\"9\" cy=\"6\" r=\"1\" fill=\"black\" />\n<circle cx=\"13\" cy=\"6\" r=\"1\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol